import { Box, Typography } from "@mui/material";

export const getDocumentTypeLabel = (
  type: number,
  t: (key: string) => string
) => {
  switch (type) {
    case 0:
      return t("documents.passport_front");
    case 3:
      return t("documents.passport_back");
    case 1:
      return t("documents.insurance");
    case 4:
      return t("documents.medical_note");
    case 2:
      return t("documents.disability_note_front");
    case 5:
      return t("documents.disability_note_back");
    default:
      return "";
  }
};

export const getOperationTypeBadge = (
  type: number,
  t: (key: string) => string
) => {
  const map: Record<number, { text: string; bg: string; color: string }> = {
    2: { text: t("notificationsPage.changing"), bg: "#C8E3FF", color: "#0090D1" },
    0: { text: t("notificationsPage.downloading"), bg: "#D4FFEF", color: "#345A3D" },
    1: { text: t("notificationsPage.delete"), bg: "#FFECEB", color: "#FA0E00" },
  };

  const item = map[type];
  if (!item) return null;

  return (
    <Box px="16px" py="8px" borderRadius="8px" sx={{ background: item.bg }} width={"min-content"}>
      <Typography fontSize={12} fontWeight={500} color={item.color} >
        {item.text}
      </Typography>
    </Box>
  );
};
